import { useState, useEffect } from 'react';
import { equipmentService } from '../services/equipmentService';
import { getImageUrl } from '../utils/imageUrl';
import { Equipment } from '../types/equipment';

export const useEquipments = () => {
	const [equipments, setEquipments] = useState<Equipment[]>([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState<string | null>(null);

	const getAllEquipments = async () => {
		try {
			setLoading(true);
			setError(null);
			const allEquipments = (await equipmentService.getAllEquipments()).map(equipment => ({
				...equipment,
				images: equipment.images.map(img => ({
					...img,
					url: getImageUrl(img.url)
				}))
			}));
			setEquipments(allEquipments);
		} catch (err) {
			setError(err instanceof Error ? err.message : 'Error loading equipments');
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		getAllEquipments();
	}, []);

	const refreshEquipments = () => {
		getAllEquipments();
	};

	return {
		equipments,
		loading,
		error,
		refreshEquipments
	};
};
